import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { HospitalProvider } from './context/HospitalContext'
import { AuthProvider } from './context/AuthContext'
import { usePageTracking } from './hooks/usePageTracking'
import RequireAuth from './components/Auth/RequireAuth'
import Login from './pages/Login/Login'
import PMHIndex from './pages/PMH/PMHIndex'
import BCBSIndex from './pages/BCBS/BCBSIndex'
import TMBIndex from './pages/TMB/TMBIndex'
import HuddleIndex from './pages/Huddle/HuddleIndex'

const RedirectWithParams: React.FC<{ to: string }> = ({ to }) => {
    const location = useLocation()
    return <Navigate to={`${to}${location.search}`} replace />
}

function AppContent() {
    usePageTracking()

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (target.closest('.export-menu')) return;
            document.querySelectorAll<HTMLElement>('.export-dropdown-menu').forEach(menu => {
                menu.style.display = 'none';
            });
            document.querySelectorAll<HTMLElement>('.export-dropdown').forEach(menu => {
                menu.classList.remove('show');
                menu.style.display = '';
            });
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <AuthProvider>
            <HospitalProvider>
                <Routes>
                    <Route path="/" element={<RedirectWithParams to="/pmh" />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/pmh/*" element={<RequireAuth projectId="207"><PMHIndex /></RequireAuth>} />
                    <Route path="/bcbs/*" element={<RequireAuth projectId="199"><BCBSIndex /></RequireAuth>} />
                    <Route path="/tmb/*" element={<RequireAuth projectId="235"><TMBIndex /></RequireAuth>} />
                    <Route path="/hdl/*" element={<RequireAuth projectId="237"><HuddleIndex /></RequireAuth>} />
                </Routes>
            </HospitalProvider>
        </AuthProvider>
    )
}

function App() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AppContent />
        </BrowserRouter>
    )
}

export default App

